const announcementBox = (text: JSX.Element, cookieName: string) => {
    const foundCookie = document.cookie.split(cookieName).length > 1;

    const cookieClicker = () => {
        var expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 400);
        var cookieValue = cookieName + '=true; expires=' + expirationDate;
        document.cookie = cookieValue;
        let notification = document.getElementById('div' + cookieName);
        if (notification) {
            notification.style.display = "none";
        }
    }

    return (<div id={'div' + cookieName} style={{ width: "99%", background: "#b2292e", maxWidth: "1075px", marginBottom: "15px", textAlign: "center", color: "white", borderRadius: "5px" }} hidden={foundCookie}>
        <span style={{ margin: "12px", display: "inline-block" }}>
            <span className="k-button-icon k-icon k-i-close" style={{ margin: "5px", float: "right", cursor: "pointer" }} onClick={cookieClicker} />
            {text}
        </span>
    </div>);
}

export const MaintenceAnnouncement = () => {
    //This is the date that the site will be down. March 23rd, 2026
    const showMaintenance = new Date(2026, 2, 23).getTime() > Date.now();

    if (showMaintenance) {
        return announcementBox(
            <>
                <span>
                    Our website will be temporarily unavailable from <b>3/21/2026</b> to <b>3/22/2026</b> while we perform scheduled maintenance. We appreciate your understanding.
                </span>
            </>,
            "showMaintenancePVS");
    } else {
        return <></>;
    }
}

export const DecommisionedAnnouncement = () => {
    return announcementBox(
        <>
            <span>
                <b>Notice:</b> Streck PVS kits and the PVS application service are discontinued. Kits that were received by <b>March 31, 2026</b> will be processed, and PVS reports will remain accessible through <b>December 31, 2026</b>.
                For questions, contact the Streck STATS department at <b>800-898-9563</b>.
            </span>
        </>,
        "afterMarchThirtyFirstCookie");
}